import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Chart } from 'chart.js';
import { StreamingStadisticsModel } from 'src/app/models/streamingStadistics/streamingStadistics';
import { StreamingService } from 'src/app/services/streaming/streaming.service';
import { StreamingStadisticsService } from 'src/app/services/streamingStadistics/streamingStadistics.service';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { MessageSeverity, AlertService } from 'src/app/shared/services/alert.service';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver';
//import ChartDataLabels from 'chartjs-plugin-datalabels';
import { sum } from 'lodash';
import { DatePipe } from '@angular/common';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { CameraService } from 'src/app/services/camera/camera.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-showroom-camera-streaming',
  templateUrl: './showroom-camera-streaming.component.html',
  styleUrls: ['./showroom-camera-streaming.component.css']
})
export class ShowroomCameraStreamingComponent implements OnInit {
  dataSource = new MatTableDataSource();
  dataSources = new MatTableDataSource();
  displayedColumns: string[] = ['index','camera',  'createdAt', 'ip', 'pc_movil', 'browser', 'origin', 'originDomain'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild('chart', { static: false }) canvas: ElementRef;
  @ViewChild('chart2', { static: false }) canvas2: ElementRef;
  @ViewChild('chart3', { static: false }) canvas3: ElementRef;
  @ViewChild('chart4', { static: false }) canvas4: ElementRef;
  enterpriseSelect: number = 0;
  enterprises = [];
  token: string;
  url: string;
  urlFile: string;
  streamingKey: string;
  id: string;
  title: string;
  reportForm: FormGroup;
  description: string;
  camerasStreaming = [] as any;
  camerasInit = [] as any;
  cameras = [] as any;
  titleCamera: string;
  cameraDescription: string;
  logo: string;
  text: string;
  searchMobile = false;
  logoEnterprise: string;
  showLive = false;
  textLive = ''; //Validando cámara
  inputSearch: string;
  inputSearchMobile: string;
  limitLengthTitleStreaming = 25;
  limitLengthDescriptionStreaming = 40;
  idCamera = 0;
  urlStadistics: string;
  successValidate = 0;
  enterpriseId = 0;
  camerasSelect = new FormControl();
  showPaginator = true;
  displayListStadistics = 'block';
  dateIView:string;
  dateFView:string;
  date = new Date();
  myDate = new Date();
  dateF = new Date();
  dateV:string;
  timeI: string;
  timeF: string;
  dataStreamingStadistics: Array<StreamingStadisticsModel>;
  cameraSelect = "TODOS";
  length = 0;
  showData = false;;
  isAdministratorStreaming=false;

  constructor(
    private formBuilder: FormBuilder,
    private datePipe: DatePipe,
    private AlertService: AlertService,
    private enterpriseService: EnterpriseService,
    private spinner: NgxSpinnerService,
    private cameraService: CameraService,
    private streamingStadisticsService: StreamingStadisticsService,
    private streamingService: StreamingService) {
      this.spinner.show();
      this.enterpriseId = parseInt(localStorage.getItem(AppConstants.Session.ENTERPRISE));
      this.camerasSelect.setValue([0]);
      //Chart.register(ChartDataLabels);
      Chart.defaults.set('plugins.datalabels', {
        color: 'black'
      });
    }


  cameraList() {
    this.cameras = [];
    this.cameraService.GetListCameraByEnterprise(this.enterpriseSelect).subscribe((response) => {
      this.cameras = this.cameras.concat(response);
      this.camerasSelect.setValue([0]);
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  ngOnInit(){
    if(parseInt(localStorage.getItem(AppConstants.Session.ROLID)) == AppConstants.UserRole.AdministradorEmpresaStreaming) this.isAdministratorStreaming = true;
    this.createForm();
    this.enterpriseSelect = parseInt(localStorage.getItem(AppConstants.Session.ENTERPRISE));
    this.cameraList();
    this.timeI = this.datePipe.transform("Tue Aug 18 2020 00:00:58 GMT-0500", 'HH:mm');
    this.timeF = this.datePipe.transform("Tue Aug 18 2020 23:59:58 GMT-0500", 'HH:mm');
    this.dateV = this.datePipe.transform(this.myDate, 'yyyy-MM-dd');
    this.setData();
    this.urlStadistics = (window.location != window.parent.location)
    ? document.referrer
    : document.location.href;
    if(!this.urlStadistics){
      if(window.location.ancestorOrigins != null){
        this.urlStadistics = window.location.ancestorOrigins[0];
      }
    }
    this.title = 'Tráfico en vivo';
    this.successValidate = 1;
    this.loadData();
  }

  ngAfterViewInit(){
    this.dataSource.paginator = this.paginator;
  }

  saveStadistics(){
    var data = {
      successValidate: this.successValidate,
      originDomain: this.urlStadistics,
      idCamera: this.idCamera,
      idEnterprise: this.enterpriseId,
      origin: 'vista individual'
    }
    this.streamingStadisticsService.createStadistics(data).subscribe(_ => {});
  }

  loadData(){

        this.streamingService.getCameraByEnterprise(parseInt(localStorage.getItem(AppConstants.Session.ENTERPRISE)),0).subscribe( _ => {
          if(_.camera != null){
            var camera = _.camera;
            if(environment.logoPrincipal != ""){
              this.logo = environment.logoPrincipal;
            }

            if(environment.logoEnterprise != ""){
              this.logoEnterprise = environment.logoEnterprise;
            }

            document.body.style.background = environment.themeColor1 + " !important";
            this.text = environment.themeColor2;
            //this.urlFile = camera.streamingFile;
            //this.streamingKey = camera.streamingKey;
            this.url = camera[0].streamingUrl;
            _.camera.forEach(function (value) {
              if(value.streamingImage == null && !value.streamingImage){
                value.streamingImage = "../../../../../assets/cameras/streaming/image-logo-stream.jpg";
              }
              else value.streamingImage =  environment.pathFile + value.streamingImage;
            });
            this.idCamera = camera[0].cameraId;
            this.camerasStreaming = _.camera.filter(_ => _.cameraId != this.idCamera);
            this.enterpriseId = _.camera[0].enterpriseId;
            this.id = "video"+camera[0].cameraId.toString();
            this.titleCamera = camera[0].camera;
            this.camerasInit =  _.camera;
            this.cameraDescription = camera[0].streamingDescription;
            this.showLive = true;
          }
          this.saveStadistics();
          this.spinner.hide();
        });

     var width = screen.width;
     if(width <= 390 && width > 360){
        this.limitLengthTitleStreaming = 8;
        this.limitLengthDescriptionStreaming = 38;
      }
     if(width <= 360){
        this.limitLengthTitleStreaming = 6;
        this.limitLengthDescriptionStreaming = 35;
     }
  }

  showStreaming(){

  }

  openCamera(item:any){
    this.spinner.show();
    this.showLive = false;
    this.cameras =  this.camerasInit.filter(_ => _.cameraId != item.cameraId );
    this.titleCamera = item.camera;
    this.description = item.description;
    this.url = item.streamingUrl;

    var _this = this;
    setTimeout(function(){
      _this.spinner.hide();
      _this.showLive = true;
    }, 2000)
  }

  search(){
    if(this.inputSearch != ""){
      var data = this.camerasStreaming.filter(x => x.camera.toLowerCase().indexOf(this.inputSearch.toLowerCase()) != -1 &&  x.cameraId != this.idCamera );
      if(data.length>0){
        this.camerasStreaming = data;
      }else{
        this.camerasStreaming = this.camerasInit.filter(x => x.cameraId != this.idCamera && x.camera.toLowerCase().indexOf(this.inputSearch.toLowerCase()) != -1 );
      }
    }else{
      this.camerasStreaming = this.camerasInit.filter(x => x.cameraId != this.idCamera );
    }
  }


  changeCameras(value){
    var init = this.camerasSelect.value[0];
    if(init == 0 && this.camerasSelect.value.includes(0) && this.camerasSelect.value.length == 2){
      this.camerasSelect.setValue(this.camerasSelect.value.filter(x => x != 0));
    }else if(this.camerasSelect.value.includes(0) && this.camerasSelect.value.length > 0){
      this.camerasSelect.setValue([0]);
    }else if(this.camerasSelect.value.length == 0){
      this.camerasSelect.setValue([0]);
    }

    var camera = this.cameras.filter(x => x.id_Camera == this.camerasSelect.value[0]);
    this.cameraSelect = camera[0].c_Camera;
  }

  searchInputMobile(){
    if(this.inputSearchMobile != ""){
      this.cameras = this.cameras.filter((x: { camera: string; }) => x.camera.toLowerCase().indexOf(this.inputSearchMobile.toLowerCase()) != -1);
    }else{
      this.cameras = this.camerasInit;
    }
  }

  showSearchMobile(){
    this.searchMobile = !this.searchMobile;
  }

  allCameras(){
    this.cameraSelect = "TODOS";
    this.camerasSelect.setValue([0]);
  }

  createForm() {
    this.reportForm = this.formBuilder.group({
        startDateReport: ['', [Validators.required]],
        endDateReport: ['', [Validators.required]],
        startTimeReport: ['', [Validators.required, Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")]],
        endTimeReport: ['', [Validators.required, Validators.pattern("^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$")]],
        cameraReport: [[], [Validators.required]],
        enterpriseReport: ['0', [Validators.required]],
        showGraph: [[]]
    });
  }

  get f() { return this.reportForm.controls; }

  _keyUp(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
      if (charCode != 46 && charCode != 58 && charCode > 31
        && (charCode < 48 || charCode > 57)) {
        return false;
      }
  }


  setFilter(){
    let search = this.reportForm.value;
    try{
      this.dateIView = search.startDateReport;
      this.dateFView = search.endDateReport;
    }catch{
      this.dateIView = search.startDateReport;
      this.dateFView = search.endDateReport;

      search.startDateReport = search.startDateReport;
      search.endDateReport = search.endDateReport;
    }

    var filterS = {
      dateI: this.datePipe.transform(this.date, 'dd/MM/yyyy').toString(),
      dateF: this.datePipe.transform(this.dateF, 'dd/MM/yyyy'),
      timeI: this.timeI,
      timeF: this.timeF,
      idCamera: this.camerasSelect.value.toString(),
      idEnterprise: this.enterpriseSelect,
    };

    return filterS;
  }

  setData(){
    this.spinner.show();
    this.streamingStadisticsService.getList(this.setFilter()).subscribe((response) => {
      if(response.error == null){
        if(response.data.length > 0){
          this.dataSource.data = response.data;
          this.paginator.pageIndex = 0;
        }else{
          this.dataSource.data = response.data;
          /*this.AlertService.showMessage(
            AppConstants.TitleModal.WARNING_TITLE,
            AppConstants.MessageModal.DATA_NULL_SEARCH,
            MessageSeverity.error);*/
        }
        this.dataStreamingStadistics = response.data;
        this.length = response.data.length;
        this.checkGraph(1);
      }
      this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }

  exportExcel(){
    this.streamingStadisticsService.downloadExportExcel(this.setFilter()).subscribe((response) => {
      const data: Blob = new Blob([response], {
        type: response.type
      });
      FileSaver.saveAs(data, 'archivo');
    });
  }

  loadChartCamerasByVisit(){
    /*var chartExist = Chart.getChart("myChart"); // <canvas> id
    if (chartExist != undefined)
      chartExist.destroy();*/

    var arrayCameras = [];
    if(this.dataStreamingStadistics.length>0){
      this.dataStreamingStadistics.forEach(element => {
        if(element.camera == null || element.camera == "" || !element.camera){ element.camera = "vista múltiple"; }
        arrayCameras.push(element.camera);
      });
    }
    var dataCameras = this.find_duplicate_in_array(arrayCameras);
    var arrayColors = [];
    var labels = Object.keys(dataCameras);
    if(dataCameras){
      labels.forEach(element => {
        arrayColors.push(this.random_rgb());
      });
    }

    var data = {
        labels: labels,
        datasets: [{
        //  data: Object.values(dataCameras),
          backgroundColor: arrayColors,
          borderColor: arrayColors,
          borderWidth: 1
        }]
      };

    return new Chart(this.canvas.nativeElement, {
      type: 'bar',
      data: data,
      options: {
        //indexAxis: 'y',
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: 'Cámaras / Cantidad de Visitas'
          },
          tooltip: {
            enabled: true,
            usePointStyle: true
          },
          datalabels: {
            display: true,
            color: 'white'
          }
        },
        layout: {
          padding: {
            left: 0,
            right: 0,
            top: 15,
            bottom: 0
          }
        },
       /* scales: {
          x: { beginAtZero: true,ticks: {stepSize:10} },
          y: { ticks: {autoSkip: false} }
        },*/
        events: [],
        responsive: true,
        maintainAspectRatio: false
      }
    });
  }

  loadPiePCMobile(){
    var arrayPCMobile = [];
    if(this.dataStreamingStadistics.length>0){
      this.dataStreamingStadistics.forEach(element => {
        arrayPCMobile.push(element.pc_movil);
      });
    }

    var dataReport = this.find_duplicate_in_array(arrayPCMobile);

    /*var chartExist = Chart.getChart("myChart2"); // <canvas> id
    if (chartExist != undefined)
      chartExist.destroy();*/
    var data = {
        datasets: [{
            data: [],//Object.values(dataReport),
            backgroundColor: [
                "#FF6384",
                "#4BC0C0",
                "#89aeeb"
            ],
            label: 'My dataset' // for legend
        }],
        labels: Object.keys(dataReport)
    };

    return new Chart(this.canvas2.nativeElement, {
      type: 'doughnut',
      data: data,
      options: {
        plugins: {
          legend: {
            display: true,
            position: 'bottom'
          },
          title: {
            display: true,
            text: '% Uso PC / Móvil'
          },
          tooltip: {
            enabled: false,
          },
          datalabels: {
            formatter: (value, ctx) => {
              let dataArr = ctx.chart.data.datasets[0].data;
              let total = sum(dataArr);     // sum from lodash
              let percentage = (value * 100 / total).toFixed(2) + "%";
              return percentage;
            },
            color: 'white',
          }
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    });
  }

  loadLineVisitByMonth(){

    var arrayVisitTime = [];
    if(this.dataStreamingStadistics.length>0){
      this.dataStreamingStadistics.forEach(element => {
        var dates =element.createdAt.split(" ");
        var date = dates[0].split("/");
        arrayVisitTime.push(date[1]+" "+date[2]);
      }); //
    }
    arrayVisitTime = arrayVisitTime.sort(function(a, b){return b.trim() - a.trim()});
    arrayVisitTime = arrayVisitTime.reverse();

    var dataReport = this.find_duplicate_in_array(arrayVisitTime);
    var arrayLabels = [];
    Object.keys(dataReport).forEach(_ => {
      var d = _.split(" ");
      var monthNames = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio",
      "Julio", "Agosto", "Setiembre", "Octubre", "Noviembre", "Diciembre"];
      var dd  = monthNames[(parseInt(d[0])-1)] + " "+ d[1];
      arrayLabels.push(dd);
    });
    /*var chartExist = Chart.getChart("myChart3");
    if (chartExist != undefined)
      chartExist.destroy();*/
    var data = {
        labels: arrayLabels,
        datasets: [{
          data: [],//Object.values(dataReport),
          fill: false,
          borderColor: 'rgb(218, 41, 28)',
          tension: 0.1
        }]
      };
    return new Chart(this.canvas3.nativeElement, {
      type: 'line',
      data: data,
      options: {
        scales: {
          xAxes: [{
              ticks: {
                  autoSkip: false,
                  maxRotation: 75,
                  minRotation: 75
              }
          }]
        },
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: 'Visitas por Mes y Año'
          },
          tooltip: {
            enabled: false,
            usePointStyle: false
          },
          datalabels: {
            display: false,
          }
        },
        events: [],
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          onComplete: function({ chart }) {
            const ctx = chart.ctx;
            ctx.textAlign = 'center';
            ctx.textBaseline = 'bottom';
            chart.config.data.datasets.forEach(function(dataset, i) {
              const meta = chart.getDatasetMeta(i);

              meta.data.forEach(function(bar, index) {
                if (dataset.data[index] > 0) {
                  var data = dataset.data[index];
                  ctx.fillText(data.toString(), bar.x, bar.y - 7);
                }
              });
            });
          }
        }
      }
    });
  }

  loadChartTypesVisit(){

    var arrayTypesVisit = [];
    if(this.dataStreamingStadistics.length>0){
      this.dataStreamingStadistics.forEach(element => {
        arrayTypesVisit.push(element.origin);
      });
    }

    var dataTypes = this.find_duplicate_in_array(arrayTypesVisit);
    var arrayColors = ['#374394','#3e8b23','#bc4004'];
    var labels = Object.keys(dataTypes);
    /*var chartExist = Chart.getChart("myChart4");
    if (chartExist != undefined)
      chartExist.destroy();*/
    var data = {
        labels: labels,
        datasets: [{
          data: [],//Object.values(dataTypes),
          backgroundColor: arrayColors,
          borderColor: arrayColors,
          borderWidth: 1
        }]
      };
    return new Chart(this.canvas4.nativeElement, {
      type: 'bar',
      data: data,
      options: {
       // indexAxis: 'x',
        plugins: {
          legend: {
            display: false
          },
          title: {
            display: true,
            text: 'Tipo de Visita / Cantidad de Visitas'
          },
          tooltip: {
            enabled: false,
            usePointStyle: false
          },
          datalabels: {
            color: 'white',
          }
        }/*,
        scales: [{
          xAxes: { beginAtZero: true,ticks: {stepSize:10} }
        }],
        events: [],
        responsive: true,
        maintainAspectRatio: false*/
      }
    });
  }

  find_duplicate_in_array(array){
    const count = {}
    const result = []

    array.forEach(item => {
        if (count[item]) {
           count[item] +=1
           return
        }
        count[item] = 1
    })

    for (let prop in count){
        if (count[prop] >=2){
            result.push(prop)
        }
    }

    return count;

    }

    random_rgb() {
      const randomBetween = (min, max) => min + Math.floor(Math.random() * (max - min + 1));
      const r = randomBetween(0, 255);
      const g = randomBetween(0, 255);
      const b = randomBetween(0, 255);
      return `rgb(${r},${g},${b})`;
    }

  checkGraph(refreshData){
    if(this.showData){
      /*var chartExist = Chart.getChart("myChart");
      var chartExist2 = Chart.getChart("myChart2");
      var chartExist3 = Chart.getChart("myChart3");
      var chartExist4 = Chart.getChart("myChart4");
      if (chartExist != undefined){
        chartExist.destroy();
        chartExist2.destroy();
        chartExist3.destroy();
        chartExist4.destroy();
      }*/
    }

    if(!refreshData){
      this.showPaginator = !this.showPaginator;
      this.showData = !this.showData;
    }

      if(this.showData){
        if(!refreshData){this.displayListStadistics = 'none';}
        this.loadChartCamerasByVisit();
        this.loadPiePCMobile();
        this.loadChartTypesVisit();
        this.loadLineVisitByMonth();
      }else{
        this.displayListStadistics = 'block';
      }

  }

  onImageError(event: any, item: any) {
    // Cuando la imagen falla al cargar, usar la imagen por defecto
    event.target.src = '../../../../../assets/cameras/streaming/image-logo-stream.jpg';
  }
}
